import React from 'react';
import sponsorshipBenefitsPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/SPONSORSHIP BENEFITS.pdf';

const ProjectPartners = () => (
	<div className="container main">
		<h2>프로젝트 파트너</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<p>
					2012년 포털이 시작된 이래로 포털을 지원해 준 아래 목록의 파트너들에게 감사드립니다.
					2015년부터 2019년까지 포털 개선 사항을 간략하게 정리한 보고서는 <a href="https://www.oecd-ilibrary.org/docserver/d8b0d605-en.pdf?expires=1660149598&id=id&accname=guest&checksum=DC849910BFB79841A703E164596516CA">여기</a>에서 확인할 수 있습니다.
				</p>
			</div>
			<div className="col-sm-6">
				<p>
					귀하의 조직이 포털 지원에 관심이 있다면, 자세한 내용은 OECD 사무국 <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>에 문의하십시오.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row partners">
			<div className="col-sm-6">
				<h2>호주</h2>
				<h4>호주 경쟁소비자위원회(Australian Competition and Consumer Commission, ACCC)</h4>
				<p>
					ACCC는 소비자와 기업, 그리고 호주 지역사회의 이익을 위해 경쟁과 공정 거래 및 제품 안전을 촉진하는 독립 법정 기관입니다.
					ACCC의 주요 책임은 2010년 경쟁 및 소비자법(Competition and Consumer Act, CCA)에 따라 경쟁, 소비자 보호, 공정 거래 및 제품 안전 조항을 준수하고 국가 인프라를 규제하며 시장 조사를 수행하는 것입니다.
				</p>
				<p>
					호주 제품 안전 규제기관인 ACCC는 다양한 필수 규격 조항 및 제품 금지 조치를 관리합니다.
					호주 전역의 소비자에게 가장 중요한 제품 안전 위험을 식별하고 해결하는 역할도 합니다.
					교육과 필요한 경우 규제를 통해 중대한 위험을 관리하기 위한 다양한 전략을 사용합니다.
				</p>
				<img src={require('../../../assets/images/logos/australian.png')} alt=""/>
				<p>
					<a href="http://www.accc.gov.au/content/index.phtml/itemId/54217#top" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
				<hr/>

				<h2>브라질</h2>
				<h4>브라질 국립계량품질기술원(National Institute of Metrology, Quality and Technology, Inmetro)</h4>
				<p>
					브라질 국립계량품질기술원(Inmetro)은 계량 및 품질에 대한 자국 내 정책 시행을 담당하는 연방 기관으로 브라질 내 무역에 대한 기술 장벽 해결에 주요 역할을 담당하는 브라질 인정 기구이며 대표 기관입니다.
				</p>
				<p>
					Inmetro는 140개 이상의 비식품 항목(<a href="http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp" target="_blank">http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp</a>) 에서 목록 참고)을 규제하는 기관으로서 제품 안전 개선을 주요 목표로 적합성 평가 프로그램을 개발합니다.
					필수 적합성 평가 프로그램이 적용되는 제품은 브라질 26개 주에서 모니터링 대상에 포함되고 평가 프로그램 규정에 위배되는 제품은 소비자를 보호하기 위해 시장에서 철수됩니다.
					Inmetro의 시장 감시 활동은 브라질 국가 표준의 중요한 변경 사항을 파악하는 데 도움이 되고, 더 나은 안전을 위한 제품 설계 수정 사항을 식별하고 필요한 경우 집행 조치를 수행하기 위한 기술적 근거를 제공하는 데에도 도움이 됩니다.
				</p>
				<img src={require('../../../assets/images/logos/inmetro.png')} alt=""/>
				<p>
					<a href="https://www.gov.br/inmetro/pt-br/canais_atendimento/ouvidoria/faca-sua-manifestacao" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
				<hr/>

				<h2>캐나다</h2>
				<h4>캐나다 보건부(Health Canada)</h4>
				<p>
					캐나다 보건부는 캐나다 국민의 건강 유지 및 향상 지원 업무를 담당하는 연방 기관입니다.
					캐나다 국민 모두의 삶을 개선하고, 기대수명과 생활 방식 및 효과적인 공공 보건 제도 이용 측면에서 세계에서 가장 건강한 국민으로 만들기 위해 노력하고 있습니다.
				</p>
				<p>
					캐나다 보건부는 규제기관으로서 일상적으로 사용하는 여러 소비재 및 화장품과 관련된 건강 위험과 안전 위해 요소를 관리하기 위해 조사, 평가 및 협업을 통해 캐나다 국민을 보호합니다.
				</p>
				<img src={require('../../../assets/images/logos/canada.png')} alt=""/>
				<p>
					<a href="http://www.healthycanadians.gc.ca/report-signalez/index-eng.php" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
				<hr/>

				<h2>멕시코</h2>
				<h4>멕시코 연방소비자보호국(Mexican Consumer Protection Federal Agency, Profeco)</h4>
				<p>
					멕시코 연방소비자보호국(Profeco)은 소비자의 권익을 증진하고 보호하기 위해 1976년에
					설립되어 행정권을 위임받은 정부 기구로, 공정함과 법적 안정성을 기반으로 한
					소비자와 기업 간 관계를 모색합니다.
				</p>
				<p>
					Profeco의 법적 체계에서는 제품, 제품 공급 관행, 위해하다고 간주되는 서비스로 인한 위험으로부터 소비자의 생명, 건강 및 안전을 보호하는 것을 소비 관계의 기본 원칙으로 간주합니다.
					이를 위해 Profeco는 특히 기술 표준 적용의 시행 및 감시를 통해 제품의 안전성과 품질을 보장하고, 제품을 평가하여 해당 제품이 기술 표준을 준수하고
					소비자의 건강이나 안전에 위험 요소가 되지 않도록 보장합니다.
				</p>
				<img src={require('../../../assets/images/logos/profeco.png')} alt=""/>
				<p>
					<a href="https://www.gob.mx/profeco/articulos/proceso-y-requisitos-de-quejas-y-denuncias" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
			</div>

			<div className="col-sm-6">
				<h2>유럽위원회</h2>
				<h4>유럽연합 집행위원회 사법 및 소비자 총국(Directorate-General for Justice and Consumers, DG JUST)</h4>
				<p>
					집행위원회는 EU의 전반적인 전략을 수립하고, 새로운 EU 법률 및 정책을 제안하며, 이행 여부를 모니터링하고, EU 예산을 관리하는 데 도움을 줍니다.
				</p>
				<p>
					유럽연합 집행위원회 사법 및 소비자 총국(DG JUST)은 EU에서 판매되는 소비재의 안전성을 보장하고, EU 내부 시장이 소비자의 이익을 위하며, EU 시민의 건강과 안전을 도모하고 증진하도록 지원합니다.
				</p>
				<p>
					DG JUST는 비식품 유해 제품에 대한 신속 경보 시스템인 안전 게이트를 관리합니다.
					이 시스템을 통해 EU 및 EEA 국가 당국은 시장에서 발견된 위험 제품에 대해 취한 조치와 관련된 모든 정보를 서로서로 신속하게 공유할 수 있습니다.
					결과적으로 유럽 단일 시장의 모든 곳에서 적절한 조치가 취해질 수 있습니다.
				</p>
				<p>
					안전 게이트는 비식품이면서 위험한 소비재(예: 장난감, 화장품, 의류)와 전문용품(예: 전동 드릴, 기계, 건축 자재)을 대상으로 합니다.
					현재 30개국 (모든 EU 회원국과 노르웨이, 아이슬란드 및 리히텐슈타인을 포함한 EEA EFTA 3개국)이 참여하고 있습니다.
				</p>
				<p><strong>법적 고지</strong></p>
				<p>
					유럽연합 집행위원회에서 제공하는 데이터는 <a href="https://ec.europa.eu/safety-gate-alerts/screen/webReport" target="_blank">안전 게이트</a> 웹사이트에 무료로 게시됩니다.
				</p>
				<p>
					시장 감시를 담당하는 회원국 당국의 <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/Safety_Gate_contacts.pdf" target="_blank">공식 연락처</a>는 안전 게이트 포털에 게시된 정보를 제공합니다.
					일반제품안전지침(General Product Safety Directive)(2001/95/EC) 부속서 2의 10장(Annex II.10) 조항에 따라 제공된 정보에 대한 책임은 정보 제공 당사자에게 있습니다.
					집행위원회는 제공된 정보의 정확성에 대해 어떠한 책임도 지지 않습니다.
				</p>
				<p><strong>재사용 경고</strong></p>
				<p>
					집행위원회의 재사용 정책은 위원회 문서 재사용에 관한 2011년 12월 12일자 위원회 결정 2011/833/EU에 명시되어 있습니다.
					안전 게이트에 게시된 정보의 재사용은 경고의 원래 의미나 메시지를 왜곡하지 않고 출처가 확인된 경우에만 승인됩니다.
				</p>

        {/*Information on reuse of alerts is available here: <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf" target="_blank">https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf</a>*/}

				<img src={require('../../../assets/images/logos/european.png')} alt=""/>
				<p>
					<a href="mailto:Sanco-Reis@ec.europa.eu" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
				<hr/>

				<h2>미국</h2>
				<h4>미국 소비자제품안전위원회(Consumer Product Safety Commission, CPSC)</h4>
				<p>
					미국 소비자제품안전위원회(CPSC)는 위원회의 관할하에 있는 수천 가지 유형의 소비재로 인한 부당한 상해나 사망 위험으로부터 소비자를 보호하는 책임을 맡고 있습니다.
					CPSC는 화재, 전기적, 화학적 또는 기계적 위험을 야기하거나 어린이에게 상해를 입힐 수 있는 제품으로부터 소비자와 가족을 보호하기 위해 노력합니다.
					CPSC가 1973년에 업무를 시작하며 장난감, 유아용 침대, 전동 공구, 담배 라이터 및 가정용 화학 제품과 같은 소비재의 안전성을 보장하기 위해 노력한 결과, 소비재 관련 사망률 및 상해율이 크게 감소했습니다.
				</p>
				<img src={require('../../../assets/images/logos/us.png')} alt=""/>
				<p>
					<a href="http://www.saferproducts.gov/" target="_blank" className="btn btn-info btn-sm">안전 문제 보고하기</a>
				</p>
				<hr/>

				<h2>GS1</h2>
				<p>
					GS1은 산업 전반의 공급망 효율성과 가시성을 개선하기 위해 글로벌 표준 및 솔루션을 개발하는 중립적인 비영리 국제 기구입니다.
					이는 무역 파트너와 산업 단체 및 기술 제공업체로 이루어진 글로벌 공동체로서, 비즈니스 요구사항을 파악하고 그에 따른 국제 표준을 개발합니다.
					GS1에는 소매 및 소비재, 보건, 운송 및 물류 등 20개 이상 업계의 약 200만 개에 달하는 사용자 단체가 회원으로 참여하고 있습니다.
					오늘날 GS1 표준 체계는 전 세계에서 가장 널리 사용되는 공급망 표준입니다.
					GS1은 110개국 이상에 현지 회원 기관을 보유하고 있으며 브뤼셀에 본사를 두고 있습니다.
					자세한 내용은 <a href="http://www.gs1.org" target="_blank">www.gs1.org</a>를 방문하시기 바랍니다.
				</p>
				<img src={require('../../../assets/images/logos/gs1.png')} alt=""/>
			</div>
		</div>
	</div>
);

export default ProjectPartners;



// WEBPACK FOOTER //
// ./src/views/static/ko/project-partners.js